import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IPagingOptions } from '@/coreDomainsModule/paging';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { DetailBaseBusinessData } from '../pages/useInventoryDashboardStore/types';
import { DetailBaseBusinessDataFactory } from '../domains/factories/DetailBaseBusinessDataFactory';

/**
 * 在庫削減ダッシュボードの概要情報を取得する
 */
export class GetInventoryDashboardDetailBaseBizUseCase {
  private repository: IInventoryRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IInventoryRepository) {
    this.repository = repository;
  }

  /**
   * 在庫削減ダッシュボードの詳細情報取得
   * @param sortType - ソートタイプ
   * @param sortTarget - ソート対象
   * @param limit - 表示制限
   * @param offset - オフセット
   * @param isExcludeNoAccuracy - 内示正答率がない取引を省くかどうか
   * @param filterItemInfo - フィルター情報
   * @returns - 在庫削減ダッシュボードの概要情報
   */
  public async execute(
    sortType?: string,
    sortTarget?: string,
    limit?: number,
    offset?: number,
    isExcludeNoAccuracy?: boolean,
    filterItemInfo?: FilterContentItem[]
  ): Promise<INetworkResult<[DetailBaseBusinessData[], IPagingOptions], IError>> {
    const filterItem = filterItemInfo ? FilterService.convertFilterObject(filterItemInfo) : undefined;
    const forecastForReceiptNameFilterItem = filterItem?.['forecastForReceiptName'];
    const forecastForReceiptResponsibleUserIdFilterItem = filterItem?.['forecastForReceiptResponsibleUserId'];
    const networkResult = await this.repository.getInventoryAnalyticsDetailsBaseBusiness(
      sortType,
      sortTarget,
      limit,
      offset,
      isExcludeNoAccuracy,
      filterItem,
      forecastForReceiptNameFilterItem,
      forecastForReceiptResponsibleUserIdFilterItem
    );

    switch (networkResult.status.type) {
      case 'success': {
        const result = networkResult.status.data;
        return {
          status: {
            type: 'success',
            data: [result.data.map((d) => DetailBaseBusinessDataFactory.create(d)), result.pagingOptions],
          },
        };
      }
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
